import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { menuItems } from '../models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService, LoggerService } from '@adreno-common';
import { combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-portal-menu',
  template: `
    <ul id="sidebarnav">
      <!-- First level menu -->
      <li
        class="sidebar-item"
        [class.active]="showMenu === sidebarnavItem.title"
        *ngFor="let sidebarnavItem of navItems$ | async"
        [routerLinkActive]="sidebarnavItem.submenu.length !== 0 ? '' : 'active'"
      >
        <div class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true">
          <i [ngClass]="[sidebarnavItem.icon]"></i>
          <span class="hide-menu">{{ sidebarnavItem.title }}</span>
        </div>
        <a
          class="sidebar-link waves-effect waves-dark"
          [routerLink]="
            sidebarnavItem.class === '' ? [sidebarnavItem.path] : null
          "
          [ngClass]="[sidebarnavItem.class]"
          *ngIf="!sidebarnavItem.extralink"
          (click)="addExpandClass(sidebarnavItem.title)"
          [routerLinkActive]="
            sidebarnavItem.submenu.length !== 0 ? '' : 'active'
          "
        >
          <i [ngClass]="[sidebarnavItem.icon]"></i>
          <span class="hide-menu"
            >{{ sidebarnavItem.title }}
            <span
              *ngIf="sidebarnavItem.label !== ''"
              [ngClass]="[sidebarnavItem.labelClass]"
              >{{ sidebarnavItem.label }}</span
            >
          </span>
        </a>
        <!-- Second level menu -->
        <ul
          aria-expanded="false"
          class="collapse first-level"
          *ngIf="sidebarnavItem.submenu.length > 0"
          [ngClass]="{ in: showMenu === sidebarnavItem.title }"
        >
          <li
            class="sidebar-item"
            *ngFor="let sidebarnavSubItem of sidebarnavItem.submenu"
            [class.active]="showSubMenu === sidebarnavSubItem.title"
            [routerLinkActive]="
              sidebarnavSubItem.submenu.length > 0 ? '' : 'active'
            "
          >
            <a
              class="sidebar-link"
              [routerLink]="
                sidebarnavSubItem.submenu.length > 0
                  ? null
                  : [sidebarnavSubItem.path]
              "
              [routerLinkActive]="
                sidebarnavSubItem.submenu.length > 0 ? '' : 'router-link-active'
              "
              [ngClass]="[sidebarnavSubItem.class]"
              *ngIf="!sidebarnavSubItem.extralink"
              (click)="addActiveClass(sidebarnavSubItem.title)"
            >
              <i [ngClass]="[sidebarnavSubItem.icon]"></i>
              <span class="hide-menu">{{ sidebarnavSubItem.title }}</span>
            </a>
            <!-- Third level menu -->
            <ul
              aria-expanded="false"
              class="collapse Second-level"
              *ngIf="sidebarnavSubItem.submenu.length > 0"
              [ngClass]="{ in: showSubMenu === sidebarnavSubItem.title }"
            >
              <li
                class="sidebar-item"
                *ngFor="let sidebarnavSubsubItem of sidebarnavSubItem.submenu"
                routerLinkActive="active"
                [ngClass]="[sidebarnavSubsubItem.class]"
              >
                <a
                  class="sidebar-link"
                  [routerLink]="[sidebarnavSubsubItem.path]"
                  *ngIf="!sidebarnavSubsubItem.extralink"
                  [routerLinkActive]="
                    sidebarnavSubsubItem.submenu.length > 0
                      ? ''
                      : 'router-link-active'
                  "
                >
                  <i [ngClass]="[sidebarnavSubsubItem.icon]"></i>
                  <span class="hide-menu">{{
                    sidebarnavSubsubItem.title
                  }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortalMenuComponent {
  @HostBinding('class') class = 'd-flex flex-column flex-grow-1';
  navItems$ = combineLatest([of(menuItems), this.auth.claims$]).pipe(
    map(([navItems, claims]) => {
      this.logger.debug('PortalMenuComponent', 'navItems$', navItems, claims)();
      return navItems
        .filter((ni1) => claims.includes(ni1.claim))
        .map((ni1) => {
          return {
            ...ni1,
            submenu: ni1.submenu
              .filter((ni2) => claims.includes(ni2.claim))
              .map((ni2) => {
                return {
                  ...ni2,
                  submenu: ni2.submenu.filter((ni3) =>
                    claims.includes(ni3.claim)
                  ),
                };
              }),
          };
        });
    })
  );
  showMenu = '';
  showSubMenu = '';

  constructor(private auth: AuthService, private logger: LoggerService) {}

  // this is for the open close
  addActiveClass(element: string): void {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  addExpandClass(element: string): void {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
}
